import { Icon, IconProps } from './Icon';

interface SendMessageIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const SendMessageIcon = ({ color = '#5E6A81', gradient, ...props }: SendMessageIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75401 12.149L10.525 20.118C10.746 21.111 12.065 21.325 12.588 20.453L20.837 6.704C21.288 5.954 20.748 5 19.873 5H4.32201C3.31901 5 2.81701 6.212 3.52601 6.921L8.75401 12.149Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M20.84 5.55957L8.75 12.1496"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
